import { render, staticRenderFns } from "./select-modalidades.vue?vue&type=template&id=21af4f0e&"
import script from "./select-modalidades.vue?vue&type=script&lang=js&"
export * from "./select-modalidades.vue?vue&type=script&lang=js&"
import style0 from "./select-modalidades.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports